var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('input',{attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":_vm.handleChange}}),_c('IconCheckbox',{attrs:{"color":_vm.color,"checked":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }